import UploadManager from './UploadManager';

// StorageManager is now just a wrapper for UploadManager
function StorageManager({ user }) {
  return <UploadManager user={user} />;
}

export default StorageManager;
